import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight, CheckCircle, Clock } from 'lucide-react';
import { Button } from '../shared/Button';

export const FinalCTA: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <section className="section-shell">
      <div className="section-container">
        <div className="rounded-[34px] bg-primary px-8 py-14 text-center text-white md:px-12">
          <span className="inline-flex rounded-full border border-white/20 bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em]">
            {t('landing.finalCta.eyebrow')}
          </span>

          <h2 className="mt-6 text-4xl font-bold leading-tight md:text-5xl lg:text-6xl">
            {t('landing.finalCta.title').split(t('landing.finalCta.titleHighlight'))[0]}
            <span className="text-secondary">{t('landing.finalCta.titleHighlight')}</span>
            {t('landing.finalCta.title').split(t('landing.finalCta.titleHighlight'))[1]}
          </h2>

          <p className="mx-auto mb-8 mt-4 max-w-3xl text-xl text-white/90 md:text-2xl">
            {t('landing.finalCta.subtitle')}
          </p>

          <div className="mb-10 flex flex-col justify-center gap-4 sm:flex-row">
          <Button 
            variant="primary" 
            size="large"
              className="bg-secondary text-lg hover:brightness-105"
            icon={<ArrowRight className="w-5 h-5" />}
            onClick={() => navigate('/try-free')}
          >
            {t('landing.finalCta.ctaPrimary')}
          </Button>
          <Button 
            variant="secondary" 
            size="large"
              className="border-white/35 bg-white/10 text-lg text-white hover:bg-white/20"
            onClick={() => navigate('/register')}
          >
            {t('common.register')}
          </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-8 text-sm text-white/85">
            <div className="flex items-center gap-2">
              <CheckCircle className="w-5 h-5 text-accent" />
              <span>{t('landing.finalCta.guarantees.noCreditCard')}</span>
            </div>
            <div className="flex items-center gap-2">
              <Clock className="w-5 h-5 text-accent" />
              <span>{t('landing.finalCta.guarantees.startNow')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
